export default {
  seller: [
    {
      name: 'Dashboard',
      url: '/dashboard',
      icon: 'icon-speedometer',
      badge: {
        variant: 'primary',
      }
    },
    {
      name: 'Users',
      url: '/Users',
      icon: 'icon-user'
    },
    {
      name: 'Orders',
      url: '/Orders',
      icon: 'icon-puzzle'
    },
    {
      name: 'Categories',
      url: '/Categories',
      icon: 'icon-note'
    },
    // {
    //   name: 'Items',
    //   url: '/Items',
    //   icon: 'icon-user'
    // },
    {
      name: 'Inventory',
      url: '/Inventory',
      icon: 'icon-puzzle'
    },
    {
      name: 'All Products',
      url: '/Products',
      icon: 'icon-layers'
    },
    {
      name: 'Disabled Products',
      url: '/DisabledProducts',
      icon: 'icon-ban'
    },
    {
      name: 'Banners',
      url: '/Banners',
      icon: 'icon-eye'
    },
  ],
  admin: [
    {
      name: 'Shops',
      url: '/Shops',
      icon: 'icon-user'
    },
  ]
}
